/**
 * Generated by scripts/generate-drizzle-schema.mjs. Do not edit by hand.
 * This product's inputs: scripts/drizzle-schema.config.mjs.
 * Regenerate: bash scripts/client-schema-fresh.sh (data-model-change skill).
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, real, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const activity_recent = sqliteTable(
  "activity_recent",
  {
    id: text("id").primaryKey(),
    scope_id: text("scope_id"),
    organization_id: text("organization_id"),
    entity_type: text("entity_type"),
    entity_id: text("entity_id"),
    action: text("action"),
    actor_user_id: text("actor_user_id"),
    actor_name: text("actor_name"),
    actor_device_id: text("actor_device_id"),
    platform: text("platform"),
    server_ts: text("server_ts"),
    client_ts: text("client_ts"),
    patch: text("patch"),
    batch_id: text("batch_id"),
    reverts_activity_id: text("reverts_activity_id"),
    chain_scope: text("chain_scope"),
    chain_seq: integer("chain_seq"),
    prev_hash: text("prev_hash"),
    row_hash: text("row_hash"),
  },
  (table) => [
    /** ORDER BY server_ts DESC in the activity feed */
    index("activity_recent_by_feed").on(table.server_ts),
    /** WHERE entity_type = ? AND entity_id = ? in entity history */
    index("activity_recent_by_entity").on(table.entity_type, table.entity_id, table.server_ts),
  ],
);

export const attachment = sqliteTable(
  "attachment",
  {
    id: text("id").primaryKey(),
    filename: text("filename"),
    content_type: text("content_type"),
    size: integer("size"),
    url: text("url"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
    hash: text("hash"),
    inspection_answer_id: text("inspection_answer_id"),
    finding_id: text("finding_id"),
    inspection_id: text("inspection_id"),
    organization_id: text("organization_id"),
    latitude: real("latitude"),
    longitude: real("longitude"),
    geo_accuracy: real("geo_accuracy"),
  },
  (table) => [
    /** WHERE user_id = ? in getHasLocalDataQuery */
    index("attachment_by_user").on(table.user_id),
    /** WHERE inspection_answer_id = ? (photos per answered item) */
    index("attachment_by_answer").on(table.inspection_answer_id, table.created_at),
    /** WHERE finding_id = ? (finding photos) */
    index("attachment_by_finding").on(table.finding_id, table.created_at),
    /** WHERE inspection_id = ? (inspector signature) */
    index("attachment_by_inspection").on(table.inspection_id),
  ],
);

export const finding = sqliteTable(
  "finding",
  {
    id: text("id").primaryKey(),
    inspection_id: text("inspection_id"),
    inspection_answer_id: text("inspection_answer_id"),
    site_id: text("site_id"),
    user_id: text("user_id"),
    organization_id: text("organization_id"),
    title: text("title"),
    description: text("description"),
    severity: text("severity"),
    status: text("status"),
    assignee_id: text("assignee_id"),
    closed_at: text("closed_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    due_date: text("due_date"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE status = ? ORDER BY updated_at (findings dashboard) */
    index("finding_by_status").on(table.status, table.severity, table.updated_at),
    /** WHERE inspection_id = ? in useFindingsByInspection */
    index("finding_by_inspection").on(table.inspection_id),
    /** WHERE user_id = ? in getHasLocalDataQuery */
    index("finding_by_user").on(table.user_id),
  ],
);

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

export const inspection = sqliteTable("inspection", {
  id: text("id").primaryKey(),
  template_id: text("template_id"),
  site_id: text("site_id"),
  user_id: text("user_id"),
  organization_id: text("organization_id"),
  inspector_id: text("inspector_id"),
  status: text("status"),
  notes: text("notes"),
  started_at: text("started_at"),
  completed_at: text("completed_at"),
  signed_at: text("signed_at"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
  template_version_id: text("template_version_id"),
});

export const inspection_answer = sqliteTable("inspection_answer", {
  id: text("id").primaryKey(),
  inspection_id: text("inspection_id"),
  template_item_id: text("template_item_id"),
  user_id: text("user_id"),
  organization_id: text("organization_id"),
  value_bool: integer("value_bool"),
  value_number: real("value_number"),
  value_text: text("value_text"),
  is_na: integer("is_na"),
  note: text("note"),
  result: text("result"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

// Small dataset per user — indexes not needed for now.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

// Small dataset — indexes not needed for now.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

// Active user sessions — small dataset, no indexes.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
});

export const site = sqliteTable("site", {
  id: text("id").primaryKey(),
  user_id: text("user_id"),
  organization_id: text("organization_id"),
  name: text("name"),
  address: text("address"),
  notes: text("notes"),
  archived: integer("archived"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const template = sqliteTable("template", {
  id: text("id").primaryKey(),
  user_id: text("user_id"),
  organization_id: text("organization_id"),
  name: text("name"),
  description: text("description"),
  archived: integer("archived"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
  current_version_id: text("current_version_id"),
  version_number: integer("version_number"),
});

export const template_item = sqliteTable("template_item", {
  id: text("id").primaryKey(),
  template_id: text("template_id"),
  user_id: text("user_id"),
  organization_id: text("organization_id"),
  section: text("section"),
  label: text("label"),
  item_type: text("item_type"),
  required: integer("required"),
  photo_required: integer("photo_required"),
  min_value: real("min_value"),
  max_value: real("max_value"),
  unit: text("unit"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  condition_item_id: text("condition_item_id"),
  condition_value: text("condition_value"),
  score: real("score"),
});

export const template_version = sqliteTable(
  "template_version",
  {
    id: text("id").primaryKey(),
    template_id: text("template_id"),
    user_id: text("user_id"),
    organization_id: text("organization_id"),
    version_number: integer("version_number"),
    name: text("name"),
    description: text("description"),
    items: text("items"),
    text: text("text"),
    client_ts: text("client_ts"),
    server_ts: text("server_ts"),
  },
  (table) => [
    /** WHERE template_id = ? ORDER BY id DESC in getTemplateVersionsQuery */
    index("template_version_by_template").on(table.template_id, table.id),
  ],
);

// Small global dataset (~20 themes) — indexes not needed.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

// Only 1 row per user — indexes not needed.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
});

export const drizzleSchema = {
  activity_recent,
  attachment,
  finding,
  font_family,
  font_variant,
  inspection,
  inspection_answer,
  member,
  organization,
  session,
  site,
  template,
  template_item,
  template_version,
  themes,
  user,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = [
  "attachment",
  "finding",
  "inspection",
  "inspection_answer",
  "site",
  "template",
  "template_item",
] as const;

export type ActivityRecent = InferSelectModel<typeof activity_recent>;
export type ActivityRecentInsert = InferInsertModel<typeof activity_recent>;
export type ActivityRecentRecord = ActivityRecent;
export type Attachment = InferSelectModel<typeof attachment>;
export type AttachmentInsert = InferInsertModel<typeof attachment>;
export type AttachmentRecord = Attachment;
export type Finding = InferSelectModel<typeof finding>;
export type FindingInsert = InferInsertModel<typeof finding>;
export type FindingRecord = Finding;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type Inspection = InferSelectModel<typeof inspection>;
export type InspectionInsert = InferInsertModel<typeof inspection>;
export type InspectionRecord = Inspection;
export type InspectionAnswer = InferSelectModel<typeof inspection_answer>;
export type InspectionAnswerInsert = InferInsertModel<typeof inspection_answer>;
export type InspectionAnswerRecord = InspectionAnswer;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type Site = InferSelectModel<typeof site>;
export type SiteInsert = InferInsertModel<typeof site>;
export type SiteRecord = Site;
export type Template = InferSelectModel<typeof template>;
export type TemplateInsert = InferInsertModel<typeof template>;
export type TemplateRecord = Template;
export type TemplateItem = InferSelectModel<typeof template_item>;
export type TemplateItemInsert = InferInsertModel<typeof template_item>;
export type TemplateItemRecord = TemplateItem;
export type TemplateVersion = InferSelectModel<typeof template_version>;
export type TemplateVersionInsert = InferInsertModel<typeof template_version>;
export type TemplateVersionRecord = TemplateVersion;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
